<script setup lang="ts">
  import type { AvailableLocale } from '@/features/locale'

  defineProps<{
    alt: string
    icon: string
    isActive: boolean
    name: string
    value: AvailableLocale
  }>()
</script>

<template>
  <div
    class="flex items-center gap-2"
    :aria-current="isActive ? true : undefined"
  >
    <img
      :src="icon"
      :alt="alt"
      class="size-4 shrink-0 text-(--n-option-text-color)"
    />
    <span class="font-medium">{{ name }}</span>
    <i
      v-if="isActive"
      aria-hidden="true"
      class="fa-regular fa-check ml-2 text-(--n-option-text-color)"
    />
  </div>
</template>
